import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServerContextInit } from "./serverContext";

export interface TrialState {
  trialFee?: number;
  noTrialActive: boolean;
  trialFeeWaived: boolean;
  hasTrialFee: boolean;
}

const initialState: TrialState = {
  noTrialActive: false,
  trialFeeWaived: false,
  trialFee: undefined,
  hasTrialFee: false,
};

const trialSlice = createSlice({
  name: "trial",
  initialState,
  reducers: {
    updateTrialFromServerContext: {
      reducer: (state, action: PayloadAction<TrialState>) => {
        return { ...state, ...action.payload };
      },
      prepare: (serverContext: ServerContextInit) => {
        let trialFee = 0;
        if (serverContext?.plans?.[4]) {
          trialFee = serverContext.plans[4].trial_fee;
        } else if (serverContext?.plan) {
          trialFee = serverContext.plan.trial_fee;
        }
        return {
          payload: {
            trialFee,
            noTrialActive: serverContext.no_trial_active,
            trialFeeWaived: serverContext.trial_fee_waived,
            hasTrialFee: !serverContext.trial_fee_waived && trialFee > 0,
          },
        };
      },
    },
  },
});

const { actions, reducer } = trialSlice;

export const { updateTrialFromServerContext } = actions;

export default reducer;
